import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-65">
      <div className="max-w-6xl mx-auto" data-id="element-66">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-67">
          {/* Is for you */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 rounded-3xl p-8 border border-green-100" data-id="element-68">
            <h3 className="text-2xl font-bold mb-8 text-navy font-serif flex items-center" data-id="element-69">
              <span className="bg-green-100 text-green-700 p-2 rounded-full mr-3" data-id="element-70">
                <Check className="w-6 h-6" data-id="element-71" />
              </span>
              Es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-72">
              {['Sos mujer 40+', 'Te despertás entre 2–4AM con frecuencia', "Sentís calor, ansiedad o 'alerta' nocturna", 'Querés algo simple, directo y aplicable hoy'].map((item, i) => <li key={i} className="flex items-start" data-id="element-73">
                  <Check className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-74" />
                  <span className="text-gray-700 text-lg" data-id="element-75">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Is NOT for you */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 rounded-3xl p-8 border border-red-100" data-id="element-76">
            <h3 className="text-2xl font-bold mb-8 text-navy font-serif flex items-center" data-id="element-77">
              <span className="bg-red-100 text-red-700 p-2 rounded-full mr-3" data-id="element-78">
                <X className="w-6 h-6" data-id="element-79" />
              </span>
              No es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-80">
              {['Buscás diagnóstico médico o tratamiento clínico', 'Tenés signos fuertes de apnea (ronquidos + pausas)', "Querés una promesa mágica de 'nunca más me despierto'", 'Buscás pastillas o suplementos'].map((item, i) => <li key={i} className="flex items-start" data-id="element-81">
                  <X className="w-5 h-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-82" />
                  <span className="text-gray-700 text-lg" data-id="element-83">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}